import { type ContinueButtonComponentProps } from '@core/blocks/edu-flow-2/components/NavigationButtons/ContinueButton';
import { ContinueButtonTypes } from '@core/blocks/edu-flow/components/Page/types';

import continueButtonsTypeDictionary from './continueButtonsTypeDictionary';

const ContinueButton: ContinueButtonComponentProps = ({ type = ContinueButtonTypes.DEFAULT_BUTTON, ...otherProps }) => {
  const CButton = continueButtonsTypeDictionary[type];

  return <CButton {...otherProps} />;
};

export default ContinueButton;
